import {NgModule} from '@angular/core';
import {AuthModule, LogLevel} from 'angular-auth-oidc-client';
import {EnvironmentHelper} from '../../../environments/environment-helper';

export function configureAuth() {
  const config = EnvironmentHelper.get('webEamConfig');
  const home = EnvironmentHelper.get('home');

  return {
    config: {
      authority: config.url,
      redirectUrl: home,
      postLogoutRedirectUri: home,
      clientId: config.clientId,
      scope: 'profile email openid address bmwids organization groups', // 'offline_access ' + your scopes
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      logLevel: LogLevel.Warn,
      renewUserInfoAfterTokenRenew: true,
      allowUnsafeReuseRefreshToken: true,
      autoUserInfo: true,
      ngswBypass: true,
      customParamsAuthRequest: {
        acr_values: 'strongAuth4000Service'
      }
    },
  }
}

@NgModule({
  imports: [AuthModule.forRoot(configureAuth())],
  exports: [AuthModule],
})
export class SsoConfigModule {
}
